import type { FC } from "react";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";

type PatientTabHeaderProps = {
  title: string;
  subTitle?: string;
  buttonLabel?: string;
  buttonOnClick?: () => void;
  optionalSwitch?: React.ReactNode;
  additionalSwitch?: React.ReactNode;
};

const PatientTabHeader: FC<PatientTabHeaderProps> = ({
  title,
  subTitle,
  buttonLabel,
  buttonOnClick,
  optionalSwitch,
  additionalSwitch,
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full overflow-x-auto overflow-y-hidden">
      {subTitle || optionalSwitch ? (
        <div className="flex flex-col gap-4">
          <h3 className="font-semibold text-gray-950 text-2xl">{title}</h3>
          {subTitle ? (
            <div className="text-xs text-gray-600">{subTitle}</div>
          ) : null}
          {optionalSwitch}
        </div>
      ) : (
        <h3 className="font-semibold text-gray-950 text-2xl">{title}</h3>
      )}
      {(buttonLabel && buttonOnClick) || additionalSwitch ? (
        <div className="flex gap-2 flex-shrink-0 sm:flex-row sm:items-center">
          {additionalSwitch}
          <Button
            variant={"outline"}
            type={"button"}
            className="gap-1 whitespace-nowrap"
            onClick={buttonOnClick}
          >
            <Plus width={20} height={20} />
            {buttonLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default PatientTabHeader;
